var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.38 5.47 15.41C5.86 15.49 6.01 15.24 6.01 15.03C6.01 14.83 6 14.28 6 13.59C3.73 14.09 3.26 12.87 3.26 12.87C2.91 11.97 2.42 11.74 2.42 11.74C1.75 11.3 2.48 11.31 2.48 11.31C3.22 11.37 3.6 12.09 3.6 12.09C4.27 13.24 5.37 12.9 5.83 12.68C5.91 12.19 6.11 11.85 6.35 11.65C4.63 11.45 2.82 10.76 2.82 7.68C2.82 6.8 3.12 6.13 3.61 5.62C3.52 5.42 3.24 4.56 3.68 3.43C3.68 3.43 4.37 3.22 6 4.26C6.63 4.07 7.32 4 8 4C8.68 4 9.37 4.07 10 4.26C11.63 3.22 12.32 3.43 12.32 3.43C12.76 4.56 12.48 5.42 12.39 5.62C12.88 6.13 13.18 6.8 13.18 7.68C13.18 10.77 11.37 11.44 9.65 11.64C9.96 11.9 10.26 12.39 10.26 13.16C10.26 14.2 10.24 14.86 10.24 15.03C10.24 15.24 10.38 15.49 10.78 15.41C13.96 14.38 16 11.54 16 8C16 3.58 12.42 0 8 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGithub);
export default __webpack_public_path__ + "static/media/nav-github.ba5d6a44d935171aff45045103fd4ecb.svg";
export { ForwardRef as ReactComponent };